import { getSourceOptions } from '@/api/work-order/options'

const state = {
	userEnumList: [] // 角色身份枚举列表
}
const mutations = {
	USER_ENUM_LIST: (state, data) => {
		state.userEnumList = data
	}
}
const actions = {
	// 获取角色身份枚举列表
	async initUserEnumList({ commit }) {
		try {
			const list = localStorage.getItem('UserEnumList')
			if (list?.length) {
				commit('USER_ENUM_LIST', JSON.parse(list))
			} else {
				const { data } = await getSourceOptions()
				commit('USER_ENUM_LIST', data?.list)
				localStorage.setItem('UserEnumList', JSON.stringify(data?.list))
			}
		} catch (error) {
			console.log('获取用户身份枚举失败', error)
		}
	}
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}
